import axios from '@/api/axios'

const getList = () => axios.get(`articles/`)
const getItem = (id) => axios.get(`articles/${id}/`)
const addItem = (data) => axios.post(`articles/`, data)
const updateItem = (id, data) => axios.patch(`articles/${id}/`, data)
const deleteItem = (id) => axios.delete(`articles/${id}/`)

export default {
  getList,
  getItem,
  addItem,
  updateItem,
  deleteItem
}